import { Skeleton } from "@mui/material";
import { ResponsivePie } from "@nivo/pie";
import useDonutChartStyles from "./DonutChart.styles";
import { ChartData } from "./DonutChart.types";

export type DonutChartProps = {
    chartData?: ChartData;
    isLoading: boolean;
    colors: string[];
};

function getContrastTextColor(hex: string): string {
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;
    const linearize = (c: number) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
    const luminance = 0.2126 * linearize(r) + 0.7152 * linearize(g) + 0.0722 * linearize(b);
    const contrastWithWhite = 1.05 / (luminance + 0.05);
    const contrastWithBlack = (luminance + 0.05) / 0.05;
    return contrastWithWhite >= contrastWithBlack ? "#FFFFFF" : "#000000";
}

function DonutChart(props: DonutChartProps) {
    const classes = useDonutChartStyles();

    return (
        <>
            {props.isLoading ? (
                <div className={classes.skeletonCircleGrid}>
                    <Skeleton animation="pulse" variant="circular" className={classes.skeletonCircle} />
                </div>
            ) : (
                <>
                    <div className={classes.root}>
                        <ResponsivePie
                            activeOuterRadiusOffset={8}
                            borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
                            borderWidth={1}
                            colors={props.colors}
                            cornerRadius={2.5}
                            data={props.chartData!.chartItems}
                            innerRadius={0.6}
                            padAngle={1}
                            enableArcLinkLabels={false}
                            arcLabelsSkipAngle={10}
                            arcLabelsTextColor={(datum: { color: string }) => getContrastTextColor(datum.color)}
                            arcLinkLabelsOffset={24}
                            arcLinkLabelsDiagonalLength={0}
                            arcLinkLabelsColor={{ from: "color" }}
                            enableArcLabels
                            arcLabel={(item: { value: any }) => item.value}
                            arcLinkLabelsTextColor="#FFFFFF"
                            margin={{ top: 10, right: 0, bottom: 10, left: 0 }}
                            theme={{
                                fontSize: 14,
                                tooltip: {
                                    basic: { fontWeight: "normal" },
                                },
                            }}
                            isInteractive
                        />
                        {props.chartData!.totalCount && (
                            <div className={classes.overlay}>
                                <span className={classes.totalCount}>{props.chartData!.totalCount}</span>
                                <span className={classes.totalCountLabel}>Registrations</span>
                            </div>
                        )}
                    </div>
                </>
            )}
        </>
    );
}

export default DonutChart;
